import React, { useState, useEffect } from "react";

export default function ValueSalesChartFilter({
  salesChartFilter,
  handleChangePaymentType,
  handleChangeMachine,
  machines,
  getData,
}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 720);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 720);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {!isMobile ? (
        <div className="row mb-2 mt-3 value-sales-filter sales-filter-row">
          <div className="col-4 sales-filter-col-left">
            <div
              className="h6 mb-0 ml-2 w-100 h-100 d-flex align-items-center"
              style={{ fontSize: ".8rem" }}
            >
              Sprzedaż bieżąca:
            </div>
          </div>

          <div className="col-8 sales-filter-col-right">
            <div className="d-flex w-100 mr-4 justify-content-between">
              <div className="form-check mr-2 d-flex align-items-center">
                <input
                  className="mr-2"
                  type="radio"
                  name="paymentType"
                  id="paymentTypeAll"
                  value=""
                  checked={!salesChartFilter.paymentType}
                  onChange={handleChangePaymentType}
                />
                <label className="form-check-label" htmlFor="paymentTypeAll">
                  Razem
                </label>
              </div>

              <div className="form-check mr-2 d-flex align-items-center">
                <input
                  className="mr-2"
                  type="radio"
                  name="paymentType"
                  id="paymentTypeCard"
                  value="1"
                  checked={salesChartFilter.paymentType === "1"}
                  onChange={handleChangePaymentType}
                />
                <label className="form-check-label" htmlFor="paymentTypeCard">
                  Karta
                </label>
              </div>

              <div className="form-check mr-2 d-flex align-items-center">
                <input
                  className="mr-2"
                  type="radio"
                  name="paymentType"
                  id="paymentTypeCash"
                  value="2"
                  checked={salesChartFilter.paymentType === "2"}
                  onChange={handleChangePaymentType}
                />
                <label className="form-check-label" htmlFor="paymentTypeCash">
                  Gotówka
                </label>
              </div>

              <div className="input-group input-group-sm w-50 ml-4">
                <input
                  className="form-control"
                  placeholder="Automat"
                  list="machines"
                  name="machine"
                  onChange={handleChangeMachine}
                  autoComplete="off"
                  defaultValue={salesChartFilter.machineName}
                  onFocus={(e) => {
                    e.target.value = "";
                    handleChangeMachine("");
                  }}
                  onBlur={(e) => !e.target.value && getData()}
                />
                <datalist id="machines">
                  {machines?.map((machine, idx) => (
                    <option
                      value={`${machine.Name} (${machine.SerialNo})`}
                      key={idx}
                    />
                  ))}
                </datalist>
              </div>

              <button
                className="btn-sm fas fa-redo redo-button ml-2"
                style={{
                  backgroundColor: "#0140BE",
                  color: "white",
                  height: "2rem",
                }}
                onClick={getData}
              ></button>
            </div>
          </div>
        </div>
      ) : (
        <div className="row mb-2 mt-3 value-sales-filter sales-filter-row mobile">
          <div className="col-12 sales-filter-header">
            <div
              className="h6 mb-0 ml-2 w-100 h-100 d-flex align-items-center"
              style={{ fontSize: ".9rem" }}
            >
              Sprzedaż bieżąca:
            </div>
          </div>

          <div className="col-12 sales-filter-options d-flex justify-content-start flex-wrap mt-2">
            {[
              { id: "All", label: "Razem", value: "" },
              { id: "Card", label: "Karta", value: "1" },
              { id: "Cash", label: "Gotówka", value: "2" },
            ].map((opt) => (
              <div
                key={opt.id}
                className="form-check mr-3 d-flex align-items-center"
              >
                <input
                  className="mr-2"
                  type="radio"
                  name="paymentType"
                  id={`paymentType${opt.id}`}
                  value={opt.value}
                  checked={salesChartFilter.paymentType === opt.value}
                  onChange={handleChangePaymentType}
                />
                <label
                  className="form-check-label"
                  htmlFor={`paymentType${opt.id}`}
                >
                  {opt.label}
                </label>
              </div>
            ))}
          </div>

          <div className="col-12 sales-filter-machine d-flex align-items-center mt-2">
            <div className="input-group input-group-sm w-100">
              <input
                className="form-control"
                placeholder="Automat"
                list="machines"
                name="machine"
                onChange={handleChangeMachine}
                autoComplete="off"
                defaultValue={salesChartFilter.machineName}
                onFocus={(e) => {
                  e.target.value = "";
                  handleChangeMachine("");
                }}
                onBlur={(e) => !e.target.value && getData()}
              />
              <datalist id="machines">
                {machines?.map((machine, idx) => (
                  <option
                    value={`${machine.Name} (${machine.SerialNo})`}
                    key={idx}
                  />
                ))}
              </datalist>
            </div>

            <button
              className="btn-sm fas fa-redo redo-button ml-2"
              style={{
                backgroundColor: "#0140BE",
                color: "white",
                height: "2rem",
              }}
              onClick={getData}
            ></button>
          </div>
        </div>
      )}
    </>
  );
}
